"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const IconPlus_vue_1 = __importDefault(require("@/components/IconPlus.vue"));
const IconMinus_vue_1 = __importDefault(require("@/components/IconMinus.vue"));
const constants_1 = require("../models/constants");
const formatted_number_1 = require("../models/formatted-number");
const lodash_es_1 = require("lodash-es");
const ENABLE_LOGGING = false;
exports.default = vue_1.default.extend({
    name: 'rows-editor',
    props: ['value', 'unit'],
    data() {
        return {
            KIND_WORK: constants_1.KIND_WORK,
            item: (() => {
                if (this.value) {
                    if (ENABLE_LOGGING)
                        console.log("this value was: ", this.value);
                    const clone = lodash_es_1.cloneDeep(this.value);
                    // turn any steps into FormattedNumber-objects
                    clone.data.step = new formatted_number_1.FormattedNumber(clone.data.step || 1000);
                    if (clone.data.sets) {
                        clone.data.sets = clone.data.sets.map((set) => {
                            if (set.kind === constants_1.KIND_WORK) {
                                set.step = new formatted_number_1.FormattedNumber(set.step || 1000);
                            }
                            return set;
                        });
                    }
                    return clone;
                }
                else {
                    // no preset found, init with default data
                    return {
                        kind: constants_1.LEVEL_KIND_SIMPLE,
                        data: {
                            prepare: 15,
                            repeat: 3,
                            work: 30,
                            step: new formatted_number_1.FormattedNumber(1000),
                            rest: 15,
                            cooldown: 20,
                        }
                    };
                }
            })(),
        };
    },
    methods: {
        setAdvanced(item, isAdvanced) {
            const value = isAdvanced ? 'advanced' : 'simple';
            if (this.item.kind === value) {
                return;
            }
            if (value === 'advanced') {
                // transform simple to advanced
                const sets = [
                    { kind: constants_1.KIND_PREPARE, value: item.data.prepare }
                ];
                for (let i = 0; i < item.data.repeat; i++) {
                    if (i > 0) {
                        sets.push({ kind: constants_1.KIND_REST, value: item.data.rest });
                    }
                    sets.push({
                        kind: constants_1.KIND_WORK,
                        value: item.data.work,
                        step: lodash_es_1.cloneDeep(item.data.step)
                    });
                }
                sets.push({ kind: constants_1.KIND_COOLDOWN, value: item.data.cooldown });
                // Vue.set(item.data, 'sets', sets);
                item.data = {
                    sets: sets
                };
            }
            else if (value === 'simple') {
                // transform advanced to simple
                const sets = item.data.sets;
                const prepare = sets[0].value;
                const cooldown = sets[sets.length - 1].value;
                const workSets = sets.filter((set) => set.kind === constants_1.KIND_WORK);
                const repeat = workSets.length;
                const workTotal = workSets.reduce((total, set) => total + set.value, 0);
                const stepTotal = workSets.reduce((total, set) => total + set.step.value, 0);
                const work = Math.round(workTotal / repeat);
                const step = new formatted_number_1.FormattedNumber(Math.round(stepTotal / repeat / 100) * 100);
                const restSets = sets.filter((set) => set.kind === constants_1.KIND_REST);
                const restTotal = restSets.reduce((total, set) => total + set.value, 0);
                const rest = Math.round(restTotal / restSets.length);
                item.data = {
                    prepare: prepare,
                    repeat: repeat,
                    work: work,
                    step: step,
                    rest: rest,
                    cooldown: cooldown
                };
            }
            item.kind = value;
        },
        setValue(level, property, value, min, max, float) {
            // TODO this is crap and probably not necessary
            try {
                // parse the input-string to a number
                let parsed;
                if (float) {
                    parsed = Math.round((parseFloat(value) * 1000) / 100) * 100;
                }
                else {
                    parsed = parseInt(value, 10);
                }
                const val = Math.min(Math.max(parsed, min), max);
                if (typeof val === 'number') {
                    let object;
                    let key;
                    if (Array.isArray(property)) {
                        // property key is nested
                        if (property.length === 0) {
                            key = property[0];
                            object = level;
                        }
                        else {
                            key = property.slice(-1)[0];
                            object = property.slice(0, -1).reduce((o, k) => o && o[k] ? o[k] : undefined, level);
                        }
                    }
                    else {
                        // property key is direct child of input
                        key = property;
                        object = level;
                    }
                    vue_1.default.set(object, key, val);
                }
            }
            catch (err) {
                if (ENABLE_LOGGING)
                    console.log("setValue error: ", err);
            }
        },
        removeSet(arr, set) {
            if (arr.filter((set) => set.kind === constants_1.KIND_WORK).length > 1) {
                // remove the rest set before the work-set or remove the rest-set after work
                const index = arr.indexOf(set);
                if (arr[index - 1].kind === constants_1.KIND_REST) {
                    vue_1.default.delete(arr, index - 1);
                }
                else if (arr.length > index + 1 && arr[index + 1].kind === constants_1.KIND_REST) {
                    vue_1.default.delete(arr, index + 1);
                }
                // remove the work row
                vue_1.default.delete(arr, arr.indexOf(set));
            }
        },
        addSet(sets) {
            // duplicate last rest set, or prepare if none is found
            for (let i = sets.length - 1; i >= 0; i--) {
                const set = sets[i];
                if (set.kind === constants_1.KIND_REST || i === 0) {
                    sets.splice(-1, 0, lodash_es_1.cloneDeep(set));
                    break;
                }
            }
            // duplicate last work set
            for (let i = sets.length - 1; i >= 0; i--) {
                const set = sets[i];
                if (set.kind === constants_1.KIND_WORK) {
                    sets.splice(-1, 0, lodash_es_1.cloneDeep(set));
                    break;
                }
            }
        },
    },
    watch: {
        item: {
            handler: function (item) {
                if (item) {
                    this.$emit('input', stripStep(item));
                }
            },
            immediate: true,
            deep: true
        }
    },
    components: {
        IconPlus: IconPlus_vue_1.default,
        IconMinus: IconMinus_vue_1.default,
    }
});
function stripStep(item) {
    if (item && item.data) {
        const clone = lodash_es_1.cloneDeep(item);
        if (clone.data.step) {
            clone.data.step = clone.data.step.value;
        }
        if (clone.data.sets) {
            clone.data.sets = clone.data.sets.map((set) => {
                if (set.step) {
                    set.step = set.step.value;
                }
                return set;
            });
        }
        return clone;
    }
    return null;
}
